var cell_default = {
  "cell": "aZPLt",
  "header": "-zXKk",
  "selected": "IUB5H",
  "editing": "_-4MEv",
  "singleSelection": "o4-Yb",
  "hideLastBlock": "I13NZ",
  "editorWrapper": "F8kW2",
  "viewerWrapper": "UJ9db",
  "hideFirstBlock": "i81-R",
  "editor": "_8HBxH",
  "edit": "PB-eH",
  "view": "Fc0yz",
  "editingToolbarWrapper": "RoOSn",
  "selectAll": "V5ntm",
  "disableSelection": "qFm5T"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
